import { parseBlob, selectCover } from "music-metadata";

export const META_V = 2;
export const TAGS = ["title", "artist", "album", "albumartist", "genre", "year", "track", "disk"];
const clean = (s) => (typeof s === "string" ? s.trim().slice(0, 200) : undefined);

export const readMeta = async (file) => {
  const { common: c } = await parseBlob(file, { duration: false, skipCovers: true });
  return { v: META_V, title: clean(c.title), artist: clean(c.artist || c.albumartist), album: clean(c.album), albumartist: clean(c.albumartist), genre: clean(c.genre?.[0]), year: c.year || undefined, track: c.track?.no || undefined, disk: c.disk?.no || undefined };
};

export const withMeta = (t, m) => {
  if (!m) return t;
  const out = { ...t };
  TAGS.forEach((k) => { if (m[k] === null) delete out[k]; else if (m[k]) out[k] = m[k]; });
  return out;
};

export const FIELDS = [["all", "Everything"], ["title", "Song title"], ["artist", "Artist"], ["album", "Album"], ["genre", "Genre"]];

export const matches = (t, field, k) => {
  if (!k) return true;
  const has = (v) => String(v || "").toLowerCase().includes(k);
  return field === "all" ? [t.title, t.artist, t.album, t.genre, t.year, t.path].some(has) : has(t[field]);
};

export const genreKey = (t) => String(t.genre || "").trim().toLowerCase();

export const genreList = (tracks) => {
  const map = new Map();
  tracks.forEach((t) => { const k = genreKey(t); if (!k) return; const g = map.get(k) || { key: k, name: t.genre.trim(), count: 0 }; g.count += 1; map.set(k, g); });
  return [...map.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
};

export const readCover = async (file) => {
  const { common } = await parseBlob(file, { duration: false, skipCovers: false });
  const pic = selectCover(common.picture);
  return pic ? new Blob([pic.data], { type: pic.format || "image/jpeg" }) : null;
};
